@if (showToggleAllocation) {
<div>
  <button type="button" ng-disabled="!moduleIsEditable" class="btn btn-primary btn-lg" (click)="toggleAllocationModule()">Allocate to this module</button>
</div>
} @else {
<div class="general-asset-container flex-column">
  @if (showMultipleAssetMessage) {
  <div class="alert alert-danger">{{multipleAssetMessage}}</div>
  }
  <form novalidate [formGroup]="assetMapSearchForm">
    @if (inactiveAssetsMessage) {
    <div class="alert alert-danger" role="alert">
      You have inactive assets allocated to this project, please remove the inactive assets.
    </div>
    }
    <div class="flex-column">
      <div class="flex-row flex-100">
        <div class="flex-25" style="padding: 10px 20px;">
          <div class="form-group flex-column">
            <label>Type</label>
            <kendo-combobox class="form-control" formControlName="AssetType"
              [data]="filteredAssetTypeList"
              [textField]="'Description'"
              [valueField]="'AssetTypeId'"
              [placeholder]="'Select Asset Type...'"
              (valueChange)="handleAssetTypeSelectionChange($event)">
            </kendo-combobox>
          </div>
        </div>
        <div class="flex-25" style="padding: 10px 20px;">
          <div class="form-group flex-column">
            <label>Name</label>
            <kendo-combobox class="form-control" formControlName="Asset"
              [data]="assetNameList"
              [textField]="'AssetName'"
              [valueField]="'AssetId'"
              [placeholder]="'Select Asset...'"
              [value]="asset"
              [filterable]="true"
              (valueChange)="handelAssetNameSelectionChange($event)"
              (filterChange)="handleAssetFilter($event)">
            </kendo-combobox>
          </div>
        </div>
        <div class="flex-25" style="padding: 10px 20px;">
          <div class="form-group flex-column">
            <label>Asset ID</label>
            <kendo-combobox class="form-control" formControlName="Asset"
              [data]="assetIdList"
              [textField]="'AssetId'"
              [valueField]="'AssetId'"
              [placeholder]="'Select Asset ID...'"
              [value]="asset"
              [filterable]="true"
              (valueChange)="handelAssetIdSelectionChange($event)"
              (filterChange)="handleAssetIdFilter($event)">
            </kendo-combobox>
          </div>
        </div>
        <div class="flex-25" style="padding: 10px 20px;">
          <div class="form-group flex-column">
            <label>Cost Center ID</label>
            <kendo-textbox class="k-textbox form-control" [readonly]="true" [value]="asset?.CostCenterNumber ?? ''"></kendo-textbox>
          </div>
        </div>
      </div>
      <div class="flex-row flex-100">
        <div class="flex-25" style="padding: 10px 20px;">
          <div class="form-group flex-column">
            <label>Cost Center</label>
            <input class="k-textbox form-control" readonly value="{{asset?.CostCenter}}">
          </div>
        </div>
        <div class="flex-25" style="padding: 10px 20px;">
          <div class="form-group flex-column">
            <label>County</label>
            <input class="k-textbox form-control" readonly value="{{asset?.County}}">
          </div>
        </div>
        <div class="flex-25" style="padding: 10px 20px;">
          <div class="form-group flex-column">
            <label>State</label>
            <input class="k-textbox form-control" readonly value="{{asset?.State}}">
          </div>
        </div>
        <div class="flex-25" style="padding: 10px 20px;">
          <form [formGroup]="assetMapForm" style="width:100%" class="flex-column">
            <label>Allocation %</label>
            <kendo-numerictextbox formControlName="AllocationPercentage" [spinners]="false" [format]="'%'" style="width: 100%;"></kendo-numerictextbox>
          </form>
        </div>
      </div>
      <div class="flex-row flex-100">
        <div class="flex-25" style="padding: 10px 20px;">
        </div>
        <div class="flex-25" style="padding: 10px 20px;">
        </div>
        <div class="flex-25" style="padding: 10px 20px;">
        </div>
        <div class="flex-25" style="padding: 10px 20px;">
          <div class="form-group flex-row">
            <input type="checkbox" name="IsInsideCityLimits" id="IsInsideCityLimits" [(ngModel)]="asset.IsInsideCityLimits" [disabled]="'true'" [ngModelOptions]="{standalone: true}">
            <label for="IsInsideCityLimits" style="margin-left: 10px;line-height: 14px;">Inside City Limits?</label>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
}